import { render } from "./bottomPanel.vue?vue&type=template&id=3a0aaf34"
import script from "./bottomPanel.vue?vue&type=script&lang=js"
export * from "./bottomPanel.vue?vue&type=script&lang=js"

import "./bottomPanel.vue?vue&type=style&index=0&id=3a0aaf34&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__